import React, { type PropsWithChildren } from 'react';

import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';

import { defaultLocale, fetchMessagesForLocale } from './fetch-messages-for-locale';

export const BSCIntlProvider = ({ children }: PropsWithChildren<{}>): React.JSX.Element => {
	return (
		<IntlMessagesProvider defaultMessages={defaultLocale} loaderFn={fetchMessagesForLocale}>
			{children}
		</IntlMessagesProvider>
	);
};
